module.exports = "<p>\n  delete-ship works!\n</p>\n"